'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { ScrollUpButton } from './ScrollUpButton';
import { StickyNavbar } from './StickyNavbar';
export type Section = {
  id: number;
  title: string;
  content: ReactNode;
};
type ScrollSpyLayoutProps = {
  sections: Section[];
};
const ACTIVE_SECTION_OFFSET_PX = 300;
export function ScrollSpyLayout(t0) {
  const $ = _c(23);
  const {
    sections
  } = t0;
  const [activeSection, setActiveSection] = useState(0);
  const [isHidden, setIsHidden] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const sectionRefs = useRef(t1);
  const stickyNavbarRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!stickyNavbarRef.current) {
        return;
      }
      const offset = stickyNavbarRef.current.getBoundingClientRect().bottom + window.scrollY - ACTIVE_SECTION_OFFSET_PX;
      setIsHidden(window.scrollY <= offset);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showArrowUpButton = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (!stickyNavbarRef.current) {
        return 0;
      }
      const container = sectionRefs.current.at(-1)?.parentElement;
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const navbarRect = stickyNavbarRef.current.getBoundingClientRect();
        if (navbarRect.bottom >= containerRect.bottom) {
          return sectionRefs.current.length - 1;
        }
      }
      let min = Number.MAX_SAFE_INTEGER;
      let current = 0;
      for (const [idx, el] of sectionRefs.current.entries()) {
        if (!el) {
          continue;
        }
        const top = el.getBoundingClientRect().top;
        const bottom = el.getBoundingClientRect().bottom;
        if (top < min && bottom > ACTIVE_SECTION_OFFSET_PX) {
          min = top;
          current = idx;
        }
      }
      return current;
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getActiveSection = t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const handleScroll = () => {
        showArrowUpButton();
        setActiveSection(getActiveSection());
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t5 = [];
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== isHidden) {
    t6 = !isHidden && <ScrollUpButton targetRef={stickyNavbarRef} />;
    $[5] = isHidden;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== sections) {
    t7 = sections.map(_temp);
    $[7] = sections;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== activeSection || $[10] !== t7) {
    t8 = <div className="self-start lg:sticky lg:top-10" ref={stickyNavbarRef}><StickyNavbar sections={t7} activeSectionId={activeSection} sectionRefs={sectionRefs} /></div>;
    $[9] = activeSection;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== sections) {
    t9 = sections.map((section, idx_0) => <div key={section.id} id={`${section.id}`} ref={el_0 => {
      sectionRefs.current[idx_0] = el_0;
    }} className="w-full max-w-2xl">{section.content}</div>);
    $[12] = sections;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div className="flex flex-col items-center">{t9}</div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="hidden lg:block" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t8) {
    t12 = <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-[270px_1fr_200px] lg:gap-4">{t8}{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t6) {
    t13 = <div>{t6}{t12}</div>;
    $[20] = t12;
    $[21] = t6;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
function _temp(s) {
  return {
    id: s.id,
    title: s.title
  };
}